import { useEffect, useState } from "react";
import { packetErrorHandler } from "../../Utils/requestUtils";

// Start the next poll only when the preceding request settles; abort on filter/unmount.
export function useKaminPolling<T>(load: (signal: AbortSignal) => Promise<T>, delay = 5000) {
  const [data, setData] = useState<T>(); const [error, setError] = useState<string>();
  useEffect(() => {
    const controller = new AbortController(); let timer: ReturnType<typeof setTimeout>;
    let failed = false;
    setData(undefined); setError(undefined);
    const poll = async () => {
      try { const value = await load(controller.signal); if (!controller.signal.aborted) { setData(value); setError(undefined); failed = false; } }
      catch (e: any) { if (!controller.signal.aborted) {
        setError(e?.response?.data?.value || "دریافت اطلاعات ناموفق بود");
        if (!failed) packetErrorHandler(e);
        failed = true;
      } }
      if (!controller.signal.aborted) timer = setTimeout(poll, delay);
    };
    void poll(); return () => { controller.abort(); clearTimeout(timer); };
  }, [load, delay]);
  return { data, error };
}
